module.exports = __webpack_public_path__ + "static/media/mafia.079e5ea5.png";